import MODULES from "@config/Modules/Shared/modules";
import { AWARD_VIDEO } from "@constants/routes";

const AWARDS_VIDEO_TITLE = "Award's Video";

const getModuleName = (pathname: string): string => {
  if (pathname.includes(AWARD_VIDEO)) {
    return AWARDS_VIDEO_TITLE;
  }

  return Object.values(MODULES)
    .flat()
    .filter(({ route }) => pathname.includes(route))[0].name;
};
export default getModuleName;
